export enum InputSizeEnum {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export type InputSizeType = keyof typeof InputSizeEnum;
